import { render } from "./BaseButtonImageToolbar.vue?vue&type=template&id=66697072"
import script from "./BaseButtonImageToolbar.vue?vue&type=script&lang=js"
export * from "./BaseButtonImageToolbar.vue?vue&type=script&lang=js"
script.render = render

export default script